"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinePoint = void 0;
const three_1 = require("three");
class LinePoint {
    constructor(point, radius, color = new three_1.Color("#29BEB0")) {
        this.point = point;
        this.radius = radius;
        this.color = color;
    }
}
exports.LinePoint = LinePoint;
